import React, { useContext, useState } from 'react';
import auth from '../services/auth';
import { UserContext } from '../context';
import { history } from '../history';
import './login.css';

function maskCnpj(digits) {
  const d = digits.slice(0, 14);
  if (d.length <= 2)  return d;
  if (d.length <= 5)  return `${d.slice(0,2)}.${d.slice(2)}`;
  if (d.length <= 8)  return `${d.slice(0,2)}.${d.slice(2,5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0,2)}.${d.slice(2,5)}.${d.slice(5,8)}/${d.slice(8)}`;
  return `${d.slice(0,2)}.${d.slice(2,5)}.${d.slice(5,8)}/${d.slice(8,12)}-${d.slice(12)}`;
}

const Login = () => {
  const [cnpj, setCnpj]               = useState('');   // dígitos puros → API
  const [cnpjDisplay, setCnpjDisplay] = useState('');   // exibição mascarada
  const [usuario, setUsuario]         = useState('');
  const [senha, setSenha]             = useState('');
  const [erro, setErro]               = useState('');
  const [carregando, setCarregando]   = useState(false);

  const context = useContext(UserContext);

  const handleCnpjChange = (e) => {
    const raw = e.target.value.replace(/\D/g, '');
    setCnpj(raw);
    setCnpjDisplay(maskCnpj(raw));
  };

  const handleSubmit = ev => {
    ev.preventDefault();
    if (!cnpj || !usuario || !senha) {
      setErro('Preencha todos os campos.');
      return;
    }
    setErro('');
    setCarregando(true);
    const url = `/dashboard/login/${cnpj}/${usuario}/${senha}`;
    auth.get(url, { auth: { username: 'Portal', password: 'Portal1163' } })
      .then(res => {
        localStorage.setItem('delphireact-token', res.data.token);
        localStorage.setItem('user-token', usuario);
        localStorage.setItem('cnpj-token', cnpj);
        localStorage.setItem('nome-token', res.data.nome);
        let cnpjs = JSON.parse(localStorage.getItem('cnpjs')) || [];
        if (!cnpjs.some(item => item.cnpj === cnpj)) {
          cnpjs.push({ cnpj, nome: res.data.nome });
        }
        localStorage.setItem('cnpjs', JSON.stringify(cnpjs));
        context.alterLogin(true);
        history.push('/');
      })
      .catch(error => {
        const status = error.response?.status;
        if (status === 500) {
          setErro('Erro no servidor (500). O serviço da API está indisponível — verifique se o sistema backend está ativo.');
        } else if (status === 401 || status === 403 || status === 404) {
          setErro('CNPJ, usuário ou senha inválidos.');
        } else if (!error.response) {
          setErro('Sem resposta do servidor. Verifique sua conexão ou se a API está rodando.');
        } else {
          setErro(`Erro ${status || 'desconhecido'}: ${error.message}`);
        }
      })
      .finally(() => setCarregando(false));
  }

  return (
    <div className="outer-container">
      <div className="limiter">
        <div className="container-login100">
          <div className="wrap-login100">
            <span className="login100-form-title p-b-26">                            
              Compsoft
            </span>
            <form onSubmit={handleSubmit}>
              <div className="wrap-input100 validate-input" data-validate="Insira seu CNPJ">
                <input
                  type="text"
                  placeholder="CNPJ (00.000.000/0000-00)"
                  value={cnpjDisplay}
                  onChange={handleCnpjChange}
                  inputMode="numeric"
                  maxLength={18}
                  autoComplete="off"
                />
              </div>
              <div className="wrap-input100 validate-input" data-validate="Insira nome de Usuário">
                <input type="text" placeholder="Usuário" onChange={(e) => setUsuario(e.target.value)} />
              </div>
              <div className="wrap-input100 validate-input">
                <input
                  className="input100"
                  type="password"
                  name="PASSWORD"
                  placeholder="Senha"
                  onChange={(e) => setSenha(e.target.value)}
                >
                </input>
              </div>
              {erro && (
                <div style={{ color: '#f43f5e', fontSize: '0.82rem', background: 'rgba(244,63,94,0.1)', border: '1px solid rgba(244,63,94,0.3)', borderRadius: 8, padding: '10px 14px', marginBottom: 16 }}>
                  <i className="fas fa-triangle-exclamation" style={{ marginRight: 6 }} />{erro}
                </div>
              )}
              <div className="container-login100-form-btn">
                <div className="wrap-login100-form-btn">
                  <div className="login100-form-bgbtn"></div>
                  <button className="login100-form-btn" type="submit" disabled={carregando}>
                    <div className="icon-text-container">
                      {carregando
                        ? <><i className="fas fa-circle-notch fa-spin" /><span className="button-text">Aguarde...</span></>
                        : <span className="button-text">Login</span>
                      }
                    </div>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Login;